export default {
    finance: {
        loanPrograms: {
            title: "Program Pinjaman",
            create: "Buat Program Pinjaman",
            edit: "Ubah Program Pinjaman",
            details: "Detail Program",
            programTitle: "Judul Program",
            programLogo: "Logo Program",
            applicationForm: "Formulir Aplikasi",
            viewApplications: "Lihat Aplikasi",
            cooperative: "Koperasi",
            bank: "Bank",
            status: "Status",
            allStatuses: "Semua status",
            active: "Aktif",
            inactive: "Tidak aktif",
            approvalFlowSetting: "Pengaturan Alur Persetujuan",
            concludeBeforeBank: "Selesaikan aplikasi pinjaman sebelum dikirim ke bank.",
            allowBankRequestInfo: "Izinkan bank meminta informasi tambahan dari pemohon.",
            currency: "Mata Uang",
            loanAmountMin: "Jumlah pinjaman - Minimum",
            loanAmountMax: "Jumlah pinjaman - Maksimum",
            term: "Jangka waktu",
            yield: "Imbal hasil",
            typeOfFinancing: "Jenis pembiayaan",
            gracePeriod: "Masa tenggang",
            country: "Negara",
            regions: "Wilayah",
            crops: "Tanaman",
            dataFields: "Field Data",
            dataFieldsConfigured: "Field data yang dikonfigurasi untuk program pinjaman ini",
            signature: "Tanda tangan",
            viewSignatureFile: "Lihat tanda tangan / file",
            description: "Deskripsi",
            conditionsRequirements: "Syarat dan ketentuan",
            digitalSignature: "Tanda tangan digital",
            fileUpload: "Unggah file",
            failedLoadLoanProgramDetails: "Gagal memuat detail program pinjaman",
            failedLoadLoanProgram: "Gagal memuat program pinjaman",
            failedLoadApplicationForm: "Gagal memuat formulir aplikasi",
            loanProgramUpdatedSuccess: "Program pinjaman berhasil diperbarui",
            loanProgramCreatedSuccess: "Program pinjaman berhasil dibuat",
            applicationFormUpdatedSuccess: "Formulir aplikasi berhasil diperbarui",
            failedUpdateLoanProgram: "Gagal memperbarui program pinjaman",
            failedCreateLoanProgram: "Gagal membuat program pinjaman",
            failedUpdateApplicationForm: "Gagal memperbarui formulir aplikasi",
            fillRequiredFields: "Harap isi semua field wajib",
            fileUploadRequiredFor: "Unggah file diperlukan untuk",
            selectAtLeastOneOptionFor: "Pilih setidaknya satu opsi untuk",
            fieldRequired: "Field ini wajib diisi",
            chooseValidOptionFor: "Pilih opsi yang valid untuk",
            enterValidAmountFor: "Masukkan jumlah yang valid untuk",
            selectValidUnitFor: "Pilih satuan yang valid untuk",
            step1ProgramDetails: "Langkah 1: Detail Program",
            step2ApplicationForm: "Langkah 2: Formulir Aplikasi",
            months: "bulan",
            years: "tahun",
            days: "hari",
            weeks: "minggu",
            previewForm: "PRATINJAU FORMULIR",
            backUpper: "KEMBALI",
            basicInformation: "Informasi Dasar",
            basicInformationHint: "Masukkan informasi dasar untuk program pinjaman.",
            enterProgramTitle: "Masukkan judul program",
            attachProgramLogo: "Lampirkan logo program",
            selectProgramLogoImage: "Pilih gambar logo program",
            selectFileUploadProgramLogo: "Pilih file untuk mengunggah logo program",
            orDragDrop: "atau seret dan lepas di sini",
            removeFile: "Hapus file",
            loanProgramSettings: "Pengaturan Program Pinjaman",
            loanProgramSettingsHint: "Masukkan pengaturan program pinjaman.",
            selectBank: "Pilih bank",
            applicationApproval: "Persetujuan Aplikasi",
            applicationProcess: "Proses Aplikasi",
            loanDetails: "Detail Pinjaman",
            loanDetailsHint: "Masukkan detail pinjaman untuk program pinjaman.",
            selectCurrency: "Pilih mata uang",
            enterMinLoanAmount: "Masukkan jumlah pinjaman minimum",
            enterMaxLoanAmount: "Masukkan jumlah pinjaman maksimum",
            enterHere: "Masukkan di sini",
            interestRate: "Suku bunga",
            yieldPerYear: "Imbal hasil - per tahun",
            enterYieldPerYear: "Masukkan imbal hasil per tahun",
            selectTypeOfFinancing: "Pilih jenis pembiayaan",
            gracePeriodMax: "Masa tenggang - Maksimum",
            selectCrops: "Pilih tanaman",
            selectCountry: "Pilih negara",
            selectRegions: "Pilih wilayah",
            addNewDataField: "TAMBAH FIELD DATA BARU",
            enterProgramDescription: "Masukkan deskripsi program",
            programApplicationForm: "Formulir aplikasi program",
            defineAndManageCustomDataFields: "Tentukan dan kelola field data khusus untuk aplikasi pinjaman.",
            addDataField: "TAMBAH FIELD DATA",
            dataField: "Field Data",
            type: "Tipe",
            subdata: "Subdata",
            mandatory: "Wajib",
            group: "Grup",
            yes: "Ya",
            no: "Tidak",
            noDataFieldsYet: "Belum ada field data. Klik TAMBAH FIELD DATA untuk membuatnya.",
            textField: "Field Teks",
            textArea: "Area Teks",
            textFieldNumeric: "Field Teks Numerik",
            radioButton: "Tombol Radio",
            checkBoxes: "Kotak Centang",
            dropdown: "Dropdown",
            measurementUnit: "Satuan Ukur",
            attachFile: "Lampirkan File",
            digitalSignatureLabel: "Tanda Tangan Digital",
            dataList: "Daftar Data",
            date: "Tanggal",
            selectDataType: "Pilih tipe data",
            fieldTitle: "Judul field",
            groupTitle: "Judul grup",
            enterGroupTitle: "Masukkan judul grup",
            allowMultipleInputs: "Izinkan banyak input",
            allowedFileTypes: "Tipe file yang diizinkan",
            imageJpegGifPng: "Gambar (JPEG, GIF, PNG)",
            videoMp4: "Video (MP4)",
            docx: "DOCX",
            options: "Opsi",
            typeHere: "Ketik di sini",
            unitType: "Tipe unit",
            selectUnitType: "Pilih tipe unit",
            selectType: "Pilih tipe",
            allowUserToChangeUnitType: "Izinkan pengguna mengubah tipe unit",
            help: "Bantuan",
            writeHelpTextUsers: "Tulis teks bantuan untuk pengguna.",
            helpText: "Teks bantuan",
            addHelpTextForThisDataField: "Tambahkan teks bantuan untuk field data ini",
            addFieldToGroup: "Tambahkan field ke grup",
            cancelUpper: "BATAL",
            submitUpper: "KIRIM",
            groupTitleRequired: "Judul grup wajib diisi",
            atLeastOneFieldRequiredInGroup: "Setidaknya satu field wajib diisi dalam grup",
            fieldTitleRequiredForAllGroupFields: "Judul field wajib diisi untuk semua field grup",
            atLeastOneOptionRequiredFor: "Setidaknya satu opsi wajib diisi untuk",
            atLeastOneFileTypeMustBeSelected: "Setidaknya satu tipe file harus dipilih",
            fieldTitleRequired: "Judul field wajib diisi",
            atLeastOneOptionRequired: "Setidaknya satu opsi wajib diisi",
        },
        loanApplications: {
            activityDescription: "Deskripsi aktivitas",
            activityLog: "Log aktivitas",
            addAnyInternalNotesOrReviewCommentsAboutThisLoanApplication: "Tambahkan catatan internal atau komentar tinjauan tentang pengajuan pinjaman ini.",
            additionalInformationRequested: "Informasi tambahan diminta",
            additionalLoanRelatedQuestionsAndSupportingDocuments: "Pertanyaan tambahan terkait pinjaman dan dokumen pendukung.",
            additionalQuestions: "Pertanyaan tambahan",
            address: "Alamat",
            amount: "Jumlah",
            applicantDetails: "Detail pemohon",
            applicationHasBeenSentToTheBankForApproval: "Pengajuan telah dikirim ke bank untuk persetujuan.",
            applicationId: "ID pengajuan",
            applicationIdAndSubmissionDate: "ID pengajuan & tanggal pengiriman",
            apply: "Terapkan",
            approvalProcess: "Proses persetujuan",
            approvalProcessHasBeenStartedYouCanNowFillFinalizeContractAndLoanDetails: "Proses persetujuan telah dimulai. Anda sekarang dapat mengisi Finalisasi kontrak dan Detail pinjaman.",
            approve: "Setujui",
            approved: "Disetujui",
            areYouSureYouWantToApproveTheLoanApplication: "Yakin ingin menyetujui pengajuan pinjaman ini?",
            areYouSureYouWantToRejectTheLoanApplication: "Yakin ingin menolak pengajuan pinjaman ini?",
            areYouSureYouWantToSendTheApplicationToTheBankForApprovalProcess: "Yakin ingin mengirim pengajuan ke bank untuk proses persetujuan?",
            areYouSureYouWantToStartTheApprovalProcess: "Yakin ingin memulai proses persetujuan?",
            area: "Luas",
            areaHa: "Luas (ha)",
            attachContractOptional: "Lampirkan kontrak (opsional)",
            attachment: "Lampiran",
            back: "Kembali",
            cancel: "Batal",
            circular: "Sirkular",
            close: "Tutup",
            closeUpper: "TUTUP",
            confirm: "Konfirmasi",
            confirmation: "Konfirmasi",
            contract: "Kontrak",
            couldNotLoadLoanApplication: "Tidak dapat memuat pengajuan pinjaman.",
            couldNotSendRequest: "Tidak dapat mengirim permintaan.",
            couldNotUpdateApplication: "Tidak dapat memperbarui pengajuan.",
            country: "Negara",
            customization: "Kustomisasi",
            date: "Tanggal",
            dateAndTime: "Tanggal & waktu",
            describeHere: "Jelaskan di sini",
            description: "Deskripsi",
            digitallySigned: "Ditandatangani secara digital",
            disclaimerTitle: "Penafian",
            disbursedAmount: "Jumlah pencairan",
            disbursementScheduleFromBankToFarmer: "Jadwal pencairan dari bank ke petani.",
            doYouWantUsToCollectTheContractSignature: "Apakah Anda ingin kami mengumpulkan tanda tangan kontrak?",
            doYouWantUsToCollectTheContractSignatureIfYesAttachTheContractOptionalAndWeWillSendItToTheFarmerToSignInTheAppIfNoTheContractIsAlreadySignedOrWillBeSignedOfflineAfterYouAttachAndSaveTheContractWillBeSentToTheFarmerToSignYouLlReceiveANotificationOnceItSSigned: "Apakah Anda ingin kami mengumpulkan tanda tangan kontrak? Jika ya, lampirkan kontrak (opsional) dan kami akan mengirimkannya ke petani untuk ditandatangani di aplikasi. Jika tidak, kontrak sudah ditandatangani atau akan ditandatangani secara offline. Setelah melampirkan dan menyimpan, kontrak akan dikirim ke petani untuk ditandatangani; Anda akan menerima pemberitahuan setelah ditandatangani.",
            download: "Unduh",
            dueDate: "Jatuh tempo",
            email: "Email",
            enterHere: "Masukkan di sini",
            error: "Kesalahan",
            farm: "Lahan",
            farmDetails: "Detail lahan",
            farmReports: "Laporan lahan",
            farmer: "Petani",
            farmerResponse: "Tanggapan petani",
            farmerUpdates: "Pembaruan petani",
            farmReportsSoilDisclaimer: "Informasi di bagian ini hanya untuk referensi umum. Tidak menggantikan analisis tanah profesional di laboratorium. Gunakan hanya jika opsi analisis tanah lain tidak tersedia. Selalu konsultasikan dengan ahli pertanian sebelum memutuskan.",
            farmReportsYieldBullet1: "Tidak mungkin memprediksi cuaca satu musim dengan akurat; dalam beberapa kasus petani bisa kehilangan seluruh panen karena hujan es atau banjir (terutama dengan pemanasan global yang menyebabkan ketidakteraturan).",
            farmReportsYieldBullet2: "Hasil sangat bergantung pada praktik pengelolaan petani. Misalnya, jika pestisida tidak disemprotkan tepat waktu atau irigasi kurang, hasil bisa sangat berbeda dari prediksi — ini juga di luar kendali kami.",
            farmReportsYieldBullet3: "Banyak faktor lain seperti di atas dapat menyebabkan kesalahan signifikan pada prediksi hasil AI.",
            farmReportsYieldBullet4: "Jika petani memberikan hasil historis (mode LANJUT), prediksi cenderung lebih akurat daripada mode default (non-LANJUT).",
            farmReportsYieldUncertaintyIntro: "Dalam prediksi hasil kami, ketidakpastian bisa mencapai 100% karena banyak faktor di luar kendali kami, termasuk:",
            forecastedYields: "Hasil perkiraan",
            graph: "Grafik",
            yieldsKgAxis: "Hasil (kg)",
            yieldForecasts: "Perkiraan hasil",
            farmerUploadedAttachmentS: "Petani mengunggah lampiran.",
            finalizeContract: "Finalisasi kontrak",
            financeManagement: "Manajemen keuangan",
            firstName: "Nama depan",
            generatePaymentSchedule: "BUAT JADWAL PEMBAYARAN",
            geolocation: "Geolokasi",
            gracePeriod: "Masa tenggang",
            gracePeriodType: "Jenis masa tenggang",
            historyOfActionsTakenOnThisLoanApplication: "Riwayat tindakan pada pengajuan pinjaman ini.",
            ifYouWantUsToCollectTheApplicantSSignatureChooseYesAndAttachTheContractAfterYouSaveItWillBeSentToTheFarmerToSignInTheAppYouLlReceiveANotificationOnceSignedContractUploadIsOptionalEGIfTheContractIsAlreadySignedOrWillBeSignedOffline: "Jika Anda ingin kami mengumpulkan tanda tangan pemohon, pilih Ya dan lampirkan kontrak. Setelah disimpan, kontrak akan dikirim ke petani untuk ditandatangani di aplikasi; Anda akan menerima pemberitahuan setelah ditandatangani. Unggah kontrak bersifat opsional — misalnya jika kontrak sudah ditandatangani atau akan ditandatangani offline.",
            information: "Informasi",
            informationRequestedFromBank: "Informasi yang diminta dari bank",
            installment: "Angsuran",
            installmentDetails: "Detail angsuran",
            interestRate: "Suku bunga",
            ipAddress: "Alamat IP",
            keySoilNutrientLevelsForTheFarm: "Tingkat nutrien tanah utama untuk lahan.",
            landSuitabilityReport: "Laporan kesesuaian lahan",
            lastName: "Nama belakang",
            loadingData: "Memuat data...",
            loanAmount: "Jumlah pinjaman",
            loanApplicationDetails: "Detail pengajuan pinjaman",
            loanApplicationHasBeenApproved: "Pengajuan pinjaman telah disetujui.",
            loanApplicationHasBeenRejected: "Pengajuan pinjaman telah ditolak.",
            loanApplications: "Pengajuan pinjaman",
            loanDetails: "Detail pinjaman",
            loanDetailsSummary: "Ringkasan detail pinjaman.",
            loanDisbursementBankFarmer: "Pencairan pinjaman (Bank -> Petani)",
            loanDisbursementPlan: "Rencana pencairan pinjaman",
            loanProgram: "Program pinjaman",
            loanPrograms: "Program pinjaman",
            loanRepaymentFarmerBank: "Pelunasan pinjaman (Petani -> Bank)",
            loanRepaymentPlan: "Rencana pelunasan pinjaman",
            missingApplicationId: "ID pengajuan tidak ada.",
            moderate: "Sedang",
            notApplicable: "T/A",
            nitrogenContent: "Kandungan nitrogen",
            noAdditionalQuestions: "Tidak ada pertanyaan tambahan.",
            noContractIsAlreadySignedOrWillBeSignedOffline: "Tidak — kontrak sudah ditandatangani atau akan ditandatangani offline",
            noMapCoordinatesForThisFarm: "Tidak ada koordinat peta untuk lahan ini.",
            notes: "Catatan",
            numberOfDisbursements: "Jumlah pencairan",
            numberOfInstallments: "Jumlah angsuran",
            of: "dari",
            openFile: "Buka file",
            orDragAndDropHere: "atau seret dan lepas di sini",
            overallLandSuitabilityScoreAndCategory: "Skor dan kategori kesesuaian lahan keseluruhan.",
            overallScoreForLandSuitability: "Skor kesesuaian lahan keseluruhan",
            paid: "Dibayar",
            paymentDetails: "Detail pembayaran",
            payments: "Pembayaran",
            pending: "Tertunda",
            phoneNumber: "Nomor telepon",
            phosphorusContent: "Kandungan fosfor",
            pleaseEnterAValidInterestRateToGenerateRepaymentPlan: "Masukkan suku bunga yang valid untuk membuat rencana pelunasan.",
            pleaseEnterAValidLoanAmountToGenerateDisbursementPlan: "Masukkan jumlah pinjaman yang valid untuk membuat rencana pencairan.",
            pleaseEnterAValidLoanAmountToGenerateRepaymentPlan: "Masukkan jumlah pinjaman yang valid untuk membuat rencana pelunasan.",
            pleaseEnterNumberOfInstallmentsToGenerateRepaymentPlan: "Masukkan jumlah angsuran untuk membuat rencana pelunasan.",
            pleaseEnterYourCommentsOrInstructions: "Masukkan komentar atau instruksi Anda.",
            pleaseProvideSpecificCommentsOrInstructionsInTheTextBoxBelowOnceSubmittedTheFarmerWillBeNotifiedYouWillBeNotifiedWhenTheFarmerUpdatesTheApplication: "Berikan komentar atau instruksi spesifik di kotak teks di bawah. Setelah dikirim, petani akan diberi tahu. Anda akan diberi tahu ketika petani memperbarui pengajuan.",
            polygon: "Poligon",
            potassiumContent: "Kandungan kalium",
            principalAndInterest: "Pokok & bunga",
            print: "Cetak",
            projectedYieldComparisonByYear: "Perbandingan hasil proyeksi per tahun.",
            provinceState: "Provinsi / Negara bagian",
            question: "Pertanyaan",
            recordsPerPage: "Catatan per halaman",
            regionDistrict: "Wilayah / Kabupaten",
            reject: "Tolak",
            rejected: "Ditolak",
            repaymentScheduleFromFarmerToBank: "Jadwal pelunasan dari petani ke bank.",
            requestAdditionalInformation: "Minta informasi tambahan",
            restoreDefault: "Pulihkan default",
            search: "Cari",
            select: "Pilih",
            selectFileToUploadTheContract: "Pilih file untuk mengunggah kontrak",
            selectNoIfYouHaveAlreadySignedTheContractWithTheApplicantFarmerSelectYesIfYouWantTheApplicantFarmerToSignTheLoanContractOnHisDimitraMobileApp: "Pilih Tidak jika Anda sudah menandatangani kontrak dengan pemohon (petani). Pilih YA jika Anda ingin pemohon (petani) menandatangani kontrak pinjaman di aplikasi seluler Dimitra.",
            send: "Kirim",
            sendToBank: "Kirim ke bank",
            sentToBank: "Terkirim ke bank",
            signedOffline: "Ditandatangani offline",
            soilAnalysisReport: "Laporan analisis tanah",
            someDisclaimerOrShortExplainerAboutFollowingReports: "Penafian atau penjelasan singkat tentang laporan berikut.",
            srd: "SRD",
            startDate: "Tanggal mulai",
            status: "Status",
            statusLegend: "Legenda status",
            submissionDate: "Tanggal pengiriman",
            success: "Berhasil",
            tapTheMapToExpandIt: "Ketuk peta untuk memperbesar.",
            thisSectionShowsAdditionalInformationRequestsSentToTheFarmerAndTheirResponses: "Bagian ini menampilkan permintaan informasi tambahan kepada petani dan tanggapannya.",
            thisSectionShowsAdditionalInformationRequestsSentToTheFarmerAndTheirResponsesYouWillBeNotifiedWhenTheFarmerUpdatesTheApplication: "Bagian ini menampilkan permintaan informasi tambahan kepada petani dan tanggapannya. Anda akan diberi tahu ketika petani memperbarui pengajuan.",
            totalInstallments: "Total angsuran",
            totalInterestApprox: "Total bunga (perkiraan)",
            totalLoanAmount: "Total jumlah pinjaman",
            totalPayment: "Total pembayaran",
            totalRepayment: "Total pelunasan",
            transactionIdAndDate: "ID transaksi & tanggal",
            typeYourLocationNameAddress: "Ketik nama atau alamat lokasi Anda",
            upcoming: "Mendatang",
            uploadTheUnsignedContractAfterYouAttachAndSaveItWillBeSentToTheFarmerToSignYouLlReceiveANotificationOnceItSSigned: "Unggah kontrak yang belum ditandatangani. Setelah melampirkan dan menyimpan, kontrak akan dikirim ke petani untuk ditandatangani. Anda akan menerima pemberitahuan setelah ditandatangani.",
            user: "Pengguna",
            userDetails: "Detail pengguna",
            userRole: "Peran pengguna",
            validation: "Validasi",
            viewFullReport: "Lihat laporan lengkap",
            viewGeolocation: "Lihat geolokasi",
            villageTownCity: "Desa / Kota",
            waitingSignatures: "Menunggu tanda tangan",
            warning: "Peringatan",
            year2025: "2025",
            year2026: "2026",
            yesAttachTheContractAndWeLlSendItToTheFarmerToSignInTheApp: "Ya — lampirkan kontrak dan kami akan mengirimkannya ke petani untuk ditandatangani di aplikasi",
            yieldPredictionReport: "Laporan prediksi hasil",
            youMayUploadTheSignedContractForYourRecordsOrLeaveEmptyIfTheContractIsPrivateOrSignedOffline: "Anda dapat mengunggah kontrak yang sudah ditandatangani untuk arsip, atau kosongkan jika kontrak bersifat pribadi atau ditandatangani offline.",
            yourRequestHasBeenSentTheFarmerWillBeNotified: "Permintaan Anda telah dikirim. Petani akan diberi tahu.",
            yieldForecastChartAria: "Grafik perkiraan hasil",
            yearsAxisLabel: "Tahun",
            soilAnalysisSectionTitle: "Analisis tanah",
            soilMetricNitrogenN: "Nitrogen (N)",
            soilMetricPhosphorusP: "Fosfor (P2O5)",
            soilMetricPotassiumK: "Kalium (K2O)",
            soilAnalysisPlaceholderTitle: "Artinya (placeholder)",
            soilAnalysisPlaceholderBody: "Halaman ini menampilkan ringkasan nutrien tanah yang disederhanakan. Setelah sumber data backend terintegrasi, bagian ini dapat diperluas menjadi grafik profil tanah lengkap dan rekomendasi.",
            landSuitabilitySectionTitle: "Kesesuaian lahan",
            overallSuitabilityScoreLabel: "Skor kesesuaian keseluruhan",
            suitabilityFactorsPlaceholder: "Faktor kesesuaian (placeholder)",
            factorSoilQuality: "Kualitas tanah",
            factorClimateFit: "Kesesuaian iklim",
            factorWaterAvailability: "Ketersediaan air",
            factorRiskFactors: "Faktor risiko",
            landSuitabilityExpertFooter: "AI bisa salah; silakan verifikasi dengan ahli agronomi setempat sebelum memutuskan.",
        },
        banks: {
            title: 'Bank',
            addNewBank: 'Tambah Bank Baru',
            bankDetails: 'Detail Bank',
            bank: 'Bank',
            bankTitle: 'Nama Bank',
            attachBankLogo: 'Unggah Logo Bank',
            addImage: 'Tambah Gambar',
            contactDetails: 'Detail Kontak',
            firstName: 'Nama Depan',
            lastName: 'Nama Belakang',
            email: 'Email',
            phone: 'Nomor Telepon',
            enterHere: 'Masukkan di sini',
            apiIntegrationInfo: 'Info Integrasi API',
            apiBaseUrl: 'URL Dasar API',
            clientId: 'ID Klien / Kunci Publik',
            clientSecret: 'Rahasia Klien / Kunci Privat',
            accountAdminCredentials: 'Kredensial Akun/Admin',
            adminUsername: 'Username Admin',
            password: 'Kata Sandi',
            require2FA: 'Wajibkan 2FA',
            enable: 'Aktifkan',
            copy: 'Salin',
            regenerate: 'Buat Ulang',
            edit: 'Ubah',
            back: 'Kembali',
            cancel: 'Batal',
            save: 'Simpan',
            firstNameInfo: 'Info Nama Depan',
            lastNameInfo: 'Info Nama Belakang',
            emailInfo: 'Info Email',
            phoneInfo: 'Info Nomor Telepon',
            apiBaseUrlInfo: 'Info URL Dasar API',
            clientIdInfo: 'Info ID Klien',
            clientSecretInfo: 'Info Rahasia Klien',
            adminUsernameInfo: 'Info Username Admin',
            passwordInfo: 'Info Kata Sandi',
            contactPerson: 'Narahubung',
            management: 'Manajemen Keuangan',
            editBank: 'Ubah Bank',
            changeImage: 'Ganti Gambar',
            failedToLoadBankDetails: 'Gagal memuat detail bank',
            bankUpdatedSuccessfully: 'Bank berhasil diperbarui',
            bankCreatedSuccessfully: 'Bank berhasil dibuat',
            errorUpdatingBank: 'Terjadi kesalahan saat memperbarui bank',
            errorCreatingBank: 'Terjadi kesalahan saat membuat bank',
            bankLogo: 'Logo Bank',
            bankLogoPreview: 'Pratinjau Logo Bank',
            notAvailable: 'Tidak tersedia',
        },
        dashboard: {
            title: "Dasbor Keuangan",
            avgLoanAmount: "Rata-rata Jumlah Pinjaman",
            vsLastMonth: "vs bulan lalu",
            totalApplications: "Total Pengajuan",
            approvalRate: "Tingkat Persetujuan",
            loanApplicationsChart: "Pengajuan Pinjaman",
            applicationsByStatus: "Pengajuan Berdasarkan Status",
            applicationsByRegion: "Pengajuan Berdasarkan Wilayah",
            regionBreakdown: "Rincian Wilayah",
            averageLoanAmountTrend: "Tren Rata-rata Jumlah Pinjaman",
            loanAmountOverTime: "Jumlah Pinjaman dari Waktu ke Waktu",
            avgAmount: "Jumlah Rata-rata"
        },
        status: {
            approved: "Disetujui",
            pending: "Tertunda",
            waiting: "Menunggu",
            rejected: "Ditolak"
        },
        reports: {
            today: "Hari ini",
            week: "Minggu",
            month: "Bulan",
            year: "Tahun"
        },
    },
}
